import { render } from "./WRequerimientos.vue?vue&type=template&id=598a2174&scoped=true"
import script from "./WRequerimientos.vue?vue&type=script&lang=js"
export * from "./WRequerimientos.vue?vue&type=script&lang=js"

import "./WRequerimientos.vue?vue&type=style&index=0&id=598a2174&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598a2174"]])

export default __exports__